import { render } from "./CreateSharedNetworkForm.vue?vue&type=template&id=63d32f3b&scoped=true"
import script from "./CreateSharedNetworkForm.vue?vue&type=script&lang=js"
export * from "./CreateSharedNetworkForm.vue?vue&type=script&lang=js"

import "./CreateSharedNetworkForm.vue?vue&type=style&index=0&id=63d32f3b&lang=less&scoped=true"

import exportComponent from "/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63d32f3b"]])

export default __exports__